import { useMemo } from "react";

import { useRoute } from "@/hooks/useRoute";

export function useBack() {
  const { f7router } = useRoute();
  return useMemo(() => f7router.back.bind(f7router), [f7router]);
}
